<template>
  <div v-if="actividades">
    <router-link to="actividades/participantes">
    <button type="button" class="btn btn-primary mb-3">Listado de actividades y participantes</button>
    </router-link>

    <table class="table table-striped table-bordered table-hover" id="tabla-actividades">
      <thead>
        <tr>
          <th>Actividad</th>
        </tr>
      </thead>
      <tbody>
        <tr class="fila-actividad" v-for="a in actividades" :key="a.id">
          <td><span class="datos-actividad" :data-id-actividad="a.id"><router-link :to="'actividad/' + a.id">{{ a.nombre }}</router-link></span></td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>

import { api } from '../api/api.js';
import { obtenerCursoActivo } from '../curso.js';

export default {
	name: 'AdminActividades',
	data () {
		return {
			actividades: null,
			curso: null,
		}
	},
	created () {
		this.obtenerActividades();
	},
	methods: {
		obtenerActividades () {
			this.curso = obtenerCursoActivo();
			api(`/actividades/${this.curso.id_curso}`)
				.then((data) => {
					this.actividades = data.resultado;
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		}
	}
}
</script>
